import { lazy } from '../../shared/deployment';
import { withIsActiveGuard } from '../utils';
import { MODULE_NAME } from './model/constants';

export * as vmFunctions from './model/vmFunctions';

const HoldingPageGuardBase = lazy(() => import('./ui/HoldingPageGuard'));

export const HoldingPageGuard = withIsActiveGuard(MODULE_NAME)(HoldingPageGuardBase);
